import { useEffect, useState } from "react";
import axios from "axios";

export default function Finansijesajtovi() {

  const [websites, setWebsites] = useState([]);
  //const [msg, setMsg] = useState("");

const token = localStorage.getItem("token"); 
  //search 
  const [search, setSearch] = useState("");


  const loadWebsites = () => {
    axios
      .get(`/api/finansijesajtovi` , {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => setWebsites(res.data))
      .catch(err => console.error(err));
  };

  useEffect(() => {
    loadWebsites();
  }, []);


    // Filtrirana lista po search inputu
    const filteredWebsites = websites.filter(w =>
        w.naziv.toLowerCase().includes(search.toLowerCase()) ||
        String(w.sajtID).includes(search) ||
        String(w.ref_num).includes(search) ||
        w.httpadresa.toLowerCase().includes(search.toLowerCase()) ||
        w.ime.toLowerCase().includes(search.toLowerCase()) ||
        w.email.toLowerCase().includes(search.toLowerCase())
    );



  return (
    <div className="card bg-dark text-white p-4">
      <h4>Websites</h4>

      {/* LOKALNI SEARCH */}
      <input
        type="text"
        className="form-control mb-3 w-25"
        placeholder="Search by ID or name..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <table className="table table-dark mt-3">
        <thead>
          <tr>
            <th>ID</th>
            <th>Naziv</th>
            <th>http://</th>
            <th>Ref</th>
            <th>Domen exp</th>
            <th>Hosting exp</th>
            <th>odrzavanje</th>
            <th>Klijent</th>
            <th>Ime</th>
            <th>Email</th>
          </tr>
        </thead>

        <tbody>
          {filteredWebsites.map(w => (
            <tr key={w.sajtID}>
              <td>{w.sajtID}</td>
              <td>{w.naziv}</td>
              <td>{w.httpadresa}</td>
              <td>{w.ref_num}</td>
              <td>{w.domen_expire}</td>
              <td>{w.hosting_expire}</td>
              <td>{w.odrzavanje}</td>
              <td>{w.klijentID}</td>
              <td>{w.ime}</td>
              <td>{w.email}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}